/*
 *	Yandex Metrika
 */ 
export const ID = 52348471;